import { render, staticRenderFns } from "./model-websiteAdvantages.vue?vue&type=template&id=626eac5a&scoped=true&"
import script from "./model-websiteAdvantages.vue?vue&type=script&lang=js&"
export * from "./model-websiteAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./model-websiteAdvantages.vue?vue&type=style&index=0&id=626eac5a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626eac5a",
  null
  
)

export default component.exports